import React from 'react';
import type { FilterSearchPropsMenu } from '@components';
import { BaseCheckbox } from '@components';
import {
    DropDownMenuRightItems,
    DropDownMenuRightItemsInnerWrapper,
    DropDownMenuRollout,
    MenuLeftItemText,
    MenuRightItem,
    SelectAllSwitchItemsCounter,
    SelectAllSwitchTrigger,
    SelectAllSwitchWrapper,
} from '@components/filter-checkbox-selector/styled.ts';
import { TEST_IDS } from '@constants/testIds.ts';
import { msg } from '@lingui/core/macro';
import { translateItem } from '@utils/translations.ts';

export const SHARED_CHECKBOX_MENU_TYPE_SELECT_ALL = msg`Select All`;
export const SHARED_CHECKBOX_MENU_TYPE_DESELECT_ALL = msg`Deselect All`;

interface Props {
    level: number;
    items: FilterSearchPropsMenu[];
    activePath: number[];
    handleLeafToggle: (path: number[] | number[][], e?: any) => void;
}

const CheckboxMenuType: React.FC<Props> = ({ level, items, activePath, handleLeafToggle }) => {
    const selectedItemsCount = items.filter((i) => i.isSelected).length;

    return (
        <DropDownMenuRollout key={level}>
            <DropDownMenuRightItems>
                <SelectAllSwitchWrapper>
                    <SelectAllSwitchTrigger
                        onClick={() => {
                            const paths = items.map((_, i) => [...activePath, i]);
                            handleLeafToggle(paths, null);
                        }}
                    >
                        {items.length > 0 && items.every((i) => i.isSelected)
                            ? translateItem(SHARED_CHECKBOX_MENU_TYPE_DESELECT_ALL)
                            : translateItem(SHARED_CHECKBOX_MENU_TYPE_SELECT_ALL)}
                    </SelectAllSwitchTrigger>
                    <SelectAllSwitchItemsCounter>
                        {selectedItemsCount} / {items.length}
                    </SelectAllSwitchItemsCounter>
                </SelectAllSwitchWrapper>
                <DropDownMenuRightItemsInnerWrapper>
                    {items.map((opt, i) => (
                        <MenuRightItem
                            data-cy={TEST_IDS.SHARED.FILTER_MENU_OPTION}
                            key={translateItem(opt.displayName as string)}
                            onClick={(e) => {
                                handleLeafToggle([...activePath, i], e);
                            }}
                        >
                            <BaseCheckbox
                                isSmallSize
                                checked={opt.isSelected}
                                onChange={(e) => {
                                    handleLeafToggle([...activePath, i], e);
                                }}
                            />
                            <MenuLeftItemText>{translateItem(opt.displayName as string)}</MenuLeftItemText>
                        </MenuRightItem>
                    ))}
                </DropDownMenuRightItemsInnerWrapper>
            </DropDownMenuRightItems>
        </DropDownMenuRollout>
    );
};

export default CheckboxMenuType;
